import api from '@/services/utils/base';
import store from '@/store';

export default class DomainsApi {
  updateUserDomainData(params:{redirectDomainId?:string, trackingDomainId?:string, rootDomain?:string,rootRedirect?:string}): Promise<Bemob.RedirectDomain[]> {
    return api.put('user', params).then((res) => {
      return Promise.resolve(res.data.payload);
    })
  };
  
  postCheckTrackingDomainDns(payload: any) {
    return api.post('user/tracking-domains/check-dns', payload).then((res) => {
      return Promise.resolve(res.data.payload);
    })
  }

  createTrackingDomain(payload: { domain:string }) {
    return api.post('user/tracking-domains', payload).then((res: any) => {
      return Promise.resolve(res.data.payload);
    });
  }

  createRedirectDomain(payload: { domain:string }) {
    return api.post('user/redirect-domains', payload).then((res: any) => {
      return Promise.resolve(res.data.payload);
    });
  }

  getTrackingDomain(id: string) {
    return api.get(`user/tracking-domains/${id}`);
  }

  deleteTrackingDomain(id: string) {
    return api.delete(`user/tracking-domains/${id}`).then((res: any) => {
      return Promise.resolve(res.data.payload);
    });
  }

  getTrackingDomains(params: any = {}) {
    return api.get('user/tracking-domains', {params}).then((res: any) => {
      return Promise.resolve(res.data.payload);
    }).catch((err: any) => {
      return Promise.reject();
    });
  }

  getRedirectDomains(params: any = {}) {
    return api.get('user/redirect-domains', {params}).then((res: any) => {
      return Promise.resolve(res.data.payload);
    }).catch((err: any) => {
      return Promise.reject();
    });
  }

  trackingDomainsPopulateStoreCache() {
    return api.get('user/tracking-domains',{
      params:{
        orderBy:'updated',
        orderDirection:'desc'
      }
    }).then((res)=>{
      store.commit('populateTrackingDomainsCache', res.data.payload);
      return Promise.resolve(res.data.payload);
    })
  }

  redirectDomainsPopulateStoreCache() {
    return api.get('user/redirect-domains',{
      params:{
        orderBy:'updated',
        orderDirection:'desc'
      }
    }).then((res)=>{
      store.commit('populateRedirectDomainsCache', res.data.payload);
      return Promise.resolve(res.data.payload);
    })
  }

  putTrackingDomain(id: string, payload: any) {
    return api.put(`user/tracking-domains/${id}`, payload).then((res: any) => {
      return Promise.resolve(res.data.payload);
    })
  }

  postCheckRedirectDomainDns(payload: any) {
    return api.post('user/redirect-domains/check-dns', payload);
  }

  postCreateRedirectDomain(payload: any) {
    return api.post('user/redirect-domains', payload);
  }

  getRedirectDomain(id: string) {
    return api.get(`user/redirect-domains/${id}`);
  }

  deleteRedirectDomain(id: string) {
    return api.delete(`user/redirect-domains/${id}`).then((res: any) => {
      return Promise.resolve(res.data.payload);
    });
  }

  getFindRedirectDomains(params: any = {}): Promise<Bemob.RedirectDomain[]> {
    return api.get('user/redirect-domains', {params}).then((res: Bemob.RawResponse<Bemob.RedirectDomain[]>) => {
      return Promise.resolve(res.data.payload);
    }).catch((err: any) => {
      return Promise.reject(err);
    });
  };
}
